import { SimpleSpinner } from '@eika/loader';
import './panel-header.scss';

interface PanelHeaderProps {
    title: string;
    showIsLoading?: boolean;
}

export const PanelHeader = ({ title, showIsLoading = false }: PanelHeaderProps) => (
    <div className="panel-header-container">
        <h3>{title}</h3>
        <div className="panel-header-container__spinner-slot">
            {showIsLoading && <SimpleSpinner mini className="panel-header-container__spinner-slot__spinner" />}
        </div>
    </div>
);
